<template>
  <div class="SignFileNM">
    <!-- #modalContent -->
    <div v-show="signModal">
      <div class="SignFileNM__certificates">
        <span class="mb-1" />
        <p v-show="isShowSelect">Выберите сертификат для подписи</p>
        <div>
          <SelectComp
            v-if="isShowSelect"
            :value="thumbprint"
            class="mb-1"
            option-field-id="thumbprint"
            option-field-name="name"
            :display-not-selected="false"
            :has-search="false"
            :options="certificateListSelectItems"
            @input="_handleSelectCertificate"
          />
          <span
            v-else-if="selectedCertificate && selectedCertificate.name"
            class="SignFileNM__certificate"
          >
            Выбранный сертификат: {{ selectedCertificate.name }}
          </span>
        </div>
        <certificate-info
          v-if="thumbprint"
          :certificate="certificateInfoValue"
        />
      </div>
    </div>

    <div
      v-show="infoMessage.message"
      class="SignFileNM__info-message"
      :style="infoMessage.style"
    >
      <Icon
        v-if="infoMessage.status === 'warning'"
        value="info"
        :ui="{ icon: 'SignFileNM__info-message__icon' }"
      />

      <span> {{ infoMessage.message }} </span>
    </div>
    <div class="SignFileNM__files">
      <span v-if="showFiles.length">Файлы, которые будут подписаны</span>
      <div class="SignFileNM__files-attr"><slot name="files"></slot></div>
    </div>
    <div style="margin: 16px 16px 16px 0">
      <Checkbox
        title="Сохранить результат подписания в файл"
        :value="saveFiles"
        :disabled="isDisabled"
        @input="v => (saveFiles = v)"
      />
    </div>
    <!-- #modalFooter -->
    <div class="SignFileNM__buttons">
      <!-- v-show="signModal" -->
      <BaseButton :disabled="isDisabled" @click.prevent="signingFile">
        <!-- SignFileNM__button: true, -->
        {{ buttonText }}
      </BaseButton>
      <slot name="buttons"></slot>
    </div>

    <slot />

    <pre v-if="debug" style="width: 300px" v-html="{ ...$data, ...$props }" />
  </div>
</template>

<script lang="ts">
import {
  createDetachedSignature,
  createHash,
  getCertificate,
  getUserCertificates,
  isValidSystemSetup,
} from 'crypto-pro';
import { Base64 } from 'js-base64';
import BaseButton from '~packages/epk-front-shared/src/ui/Button/Button.vue';
import { Checkbox, Icon } from '~packages/epk-front-shared/ui';

// import { inject } from 'vue';
import mime from '@/constants/mime';
import unProxy from '@/helpers/unProxy';
import { applySignInfo, getTimeFromPKCS7, getZip } from '@/utils/_sign';
import SelectComp from '@mkskom/components/Select';

import { CertificateInfo } from '../CertificateInfo';

export default {
  name: 'SignFileNM',

  components: {
    Icon,
    BaseButton,
    Checkbox,
    SelectComp,
    CertificateInfo,
  },

  props: {
    id: {
      type: Number,
      default: 0,
    },

    buttonText: {
      type: String,
      default: 'Подписать документ',
    },
    signData: { type: Object, required: true },
    signing: Boolean /** flag of signing process: can use .sync */,
    loading: Boolean /** flag of loading certificates: can use .sync */,
    debug: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * @param {Function || Function<Promise>} - will be called on button click, before other actions
     */
    actionBefore: {
      type: Function,
      default: () => null,
    },
    btnClass: {
      type: String,
      default: 'SignFileNM__button',
    },
    fileName: {
      type: String,
      default: 'file',
    },
    setApproveFile: {
      type: Function,
      default: () => null,
    },
    showFiles: {
      type: Array,
      default: () => [],
    },
    signingFileList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['selectedCertificate', 'error', 'success', 'approve', 'unApprove'],
  data() {
    return {
      saveFiles: true, // сохранять результат подписания в файл
      infoMessage: { style: 'color: black', message: '', status: '' },
      thumbprint: '',
      signModal: true,
      certList: [],
      signResult: {},
      signType: null,
      cert: null,
      certIsValid: false,
      certificateInfoValue: {},
      signButtonWasPressed: false,
    };
  },
  computed: {
    signDataBase64() {
      return this.signData.base64;
    },
    signDataType() {
      return this.signData.type;
    },
    isCertificateSelected: function () {
      return this.thumbprint !== '';
    },
    isValidSignData: function () {
      return this.signData.base64 instanceof ArrayBuffer;
    },
    isDisabled: function () {
      return (
        !this.thumbprint ||
        !this.certIsValid ||
        !this.isValidSignData ||
        this.signButtonWasPressed
      ); // !cert.isValid() ||
    },
    isShowSelect: function () {
      return this.certificateListSelectItems.length > 1;
    },
    certificateListSelectItems: function () {
      return this.certList;
    },
    selectedCertificate() {
      const thumbprint = this.thumbprint;
      const certificate = thumbprint
        ? this.certList.find(cert => cert.thumbprint === thumbprint)
        : {};
      this.$emit('selectedCertificate', certificate);
      return certificate;
    },
  },
  watch: {
    signData() {
      console.log('watch signData');
      this.prepareData();
    },
  },
  created() {
    this.init();
  },
  methods: {
    _handleSelectCertificate(thumbprint) {
      this.setCertificate(thumbprint);
    },

    // createNotificationFromCatch(error) {
    //   this.createNotification({
    //     type: 'error',
    //     message: String(error).replace('Error: ', ''),
    //   });
    // },

    async setCertificate(thumbprint) {
      console.log('thumbprint', thumbprint);
      this.cert = await getCertificate(thumbprint);
      this.certIsValid = await this.cert.isValid();
      this.thumbprint = thumbprint;
      await this.setCertificateInfo();
    },

    async doAction() {
      // check data
      const checkEcpFunctionality = await isValidSystemSetup();
      if (!checkEcpFunctionality) {
        this.setInfoMessage({
          style: 'color: red',
          message: 'Настройки ЭП некорректны',
        });
        // createNotification({
        //   type: 'error',
        //   message: 'Настройки ЭП некорректны',
        // });
        return;
      }
      if (!this.isValidSignData) {
        const errorMessage =
          'Нет данных для подписи, или данные предоставлены в неверном формате';

        this.$emit('error', { head: 'Ошибка', text: errorMessage });

        return;
      }

      this.setInfoMessage({
        style: 'color: blue',
        message: 'Выполняется операция чтения доступных сертификатов...',
      });
      this.certList = await getUserCertificates();
      this.setInfoMessage({ style: 'color: black', message: '' });
      console.info('Загружен список сертификатов:', unProxy(this.certList));

      // select first cert
      if (!this.thumbprint && this.certList.length) {
        await this.setCertificate(this.certList[0].thumbprint);
      }

      // open modal
      this.signModal = true;
    },
    async prepareData() {
      console.log('SignFileNoModal> prepareData');
      if (this.disabled) return null;
      try {
        if (this.actionBefore) {
          await this.actionBefore();
        }
        await this.doAction();
      } catch (error) {
        console.log(String(error));
        this.setInfoMessage({
          style: 'color: var(--color-primary-500)',
          message: 'У вас нет валидных сертификатов',
          status: 'warning',
        });
        this.createNotificationFromCatch(error);
      }
    },
    async init() {
      this.thumbprint = '';
    },
    async setCertificateInfo() {
      function makeString(value, titles = null) {
        if (titles) {
          return value
            .filter(v => titles.includes(v.title))
            .map(v => v.description)
            .join(', ');
        }
        return value.map(v => `${v.title}=${v.description}`).join(', ');
      }

      // function toHexString(bytes) {
      //   return Array.from(bytes, byte => {
      //     return ('0' + (byte & 0xff).toString(16)).slice(-2);
      //   }).join('');
      // }

      function dateAsString(d) {
        const s = new Date(d).toLocaleString('ru');
        return s.slice(0, s.indexOf(','));
      }

      const cert = this.selectedCertificate;
      const [issuer, owner] = await Promise.all([
        cert.getIssuerInfo(),
        cert.getOwnerInfo(),
      ]);
      this.certificateInfoValue = {
        valid: `с ${dateAsString(cert.validFrom)} по ${dateAsString(
          cert.validTo
        )}`,
        thumbprint: cert.thumbprint,
        issuer: makeString(issuer, ['Удостоверяющий центр', 'Компания']),
        issuerFull: makeString(issuer),
        owner: makeString(owner, ['Компания', 'Email']),
        ownerFull: makeString(owner),
      };
    },
    getCertInfoToPrint(signDate) {
      return Object.assign(this.certificateInfoValue, {
        signDate,
      });
    },

    setInfoMessage(message) {
      // console.warn('setInfoMessage>', message);
      this.infoMessage = message;
    },

    async signingFile() {
      this.signButtonWasPressed = true;
      // this.$emit('update:signing', true);
      const cert = this.cert; // await getCertificate(this.selectedCertificate.thumbprint);
      const certificateBase64 = await cert.exportBase64();
      try {
        this.setInfoMessage({
          style: 'color: blue',
          message: 'Выполняется подписание ЭП',
        });

        // сертификат сохраняем у себя, и даем скачать здесь, где галочка, если режим xml
        // (пользователю, который подписал);
        // в остальном - он будет внедрен в скачиваемую xml, а скачать его в архиве не даем,
        // т.к.непонятно зачем он нужен пользователю - лишнего не отгружаем.
        // const blobCert = new Blob([Base64.toUint8Array(certificateBase64)], {
        //   type: mime.cert,
        // });
        // let blobPrintPdf = undefined;
        // console.log(349, this.saveFiles, unref(this.saveFiles));
        // this.setInfoMessage({
        //   style: 'color: blue',
        //   message: 'Выполняется формирование zip-архива',
        // });

        const filesInfo = [];

        const pdfFactory = async (file: BlobPart, prefixName = null) => {
          const prefix = !prefixName ? '' : `${prefixName}-`;
          const fileListName =
            this.signingFileList.length && prefixName
              ? ` с ${this.signingFileList[prefixName - 1]}`
              : '';

          const messageHash = await createHash(file as string);
          const sigResult = await createDetachedSignature(
            this.thumbprint,
            messageHash
          );
          const currentTime = new Date().toLocaleString('ru');
          const blobSign = new Blob([Base64.toUint8Array(sigResult)], {
            type: mime.p7s,
          });

          const signTime = getTimeFromPKCS7();
          const info = this.getCertInfoToPrint(signTime || currentTime); // т.к. там время, формируем как можно раньше

          filesInfo.push({
            filename: `${prefix}${this.fileName}${fileListName}.pdf`,
            blob: new Blob([file], {
              type: mime.pdf,
            }),
          });
          const printingPdf = await applySignInfo(file, info);
          const blobPrintPdf = new Blob([printingPdf], {
            type: mime.pdf,
          });
          filesInfo.push({
            filename: `${prefix}${this.fileName}${fileListName}.print.pdf`,
            blob: blobPrintPdf,
          });
          filesInfo.push({
            filename: `${prefix}${this.fileName}${fileListName}.p7s`,
            blob: blobSign,
          });

          this.$emit('approve', !prefixName ? 1 : prefixName);
        };

        if (this.showFiles.length > 0) {
          for (const { file, id } of this.showFiles) {
            await pdfFactory(file, id);
          }
        } else {
          await pdfFactory(this.signDataBase64);
        }

        // if (this.signData.type === 'pdf') {

        // } else if (this.signData.type === 'xml') {
        //   filesInfo.push({
        //     filename: this.fileName + '.xml',
        //     blob: new Blob([this.signDataBase64], {
        //       type: 'application/xml',
        //     }),
        //   });
        //   filesInfo.push({
        //     filename: this.fileName + '.cert',
        //     blob: blobCert,
        //   });
        // }

        this.signData.additionalFiles.forEach(({ filename, blob }, idx) => {
          filesInfo.push({ filename: `${++idx}-${filename}`, blob });
        });

        const blobZip = await getZip(filesInfo, this.setInfoMessage);

        this.$emit('success', {
          // signature: blobSign,
          // certificate: blobCert,
          // print: blobPrintPdf,
          zip: blobZip,
          needSaveFiles: this.saveFiles,
        });
        // createNotification({
        //   type: 'success',
        //   message: 'Отчет успешно подписан',
        // });

        this.signModal = false;
      } catch (error) {
        // this.createNotificationFromCatch(error);
        this.setInfoMessage({
          style: 'color: red',
          message: String(error).replace('Error: ', ''),
        });
        this.$emit('unApprove');

        // this.$emit('error', { head: 'Ошибка', text: error });
        this.signButtonWasPressed = false;
        return;
      }
      this.setInfoMessage({ style: 'color: black', message: '' });

      // this.$emit('update:signing', false);
    },
  },
};
</script>
<style lang="scss" scoped src="./SignFileNoModal.scss" />
